import React, { useEffect, useRef, useState } from "react";
import { Modal, Alert, Button, Table, Row, Col } from "react-bootstrap";
import CellSelector from "./CellSelector";
import ApiManager from "../utils/ApiManager"; // Importa ApiManager
import "./Modal.css";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { v4 as uuidv4 } from "uuid";
import RowCountLabel from "./RowCountLabel";
import CheckBoxComponent from "./CheckBoxComponent";
import DataManager from "../utils/DataManager";
import ProductLink from "./ProductLink";

const ModalMovementIncomings = ({
  movReason,
  movements,
  onCheckedChange,
  showModal,
  setShowModal,
  onSaveModal,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [error, setError] = useState(null);
  const [selectedWarehouseAreaId, setSelectedWarehouseAreaId] = useState("");
  const [selectedWarehouseAreaDescr, setSelectedWarehouseAreaDescr] =
    useState("");
  const [selectedRack, setSelectedRack] = useState("");
  const [selectedCol, setSelectedCol] = useState("");
  const [selectedShelf, setSelectedShelf] = useState("");
  const [receivingList, setReceivingList] = useState([]);
  const [validationError, setValidationError] = useState("");
  const warehouseAreaRef = useRef(null);
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => currentYear - i);

  useEffect(() => {
    if (onCheckedChange) {
      onCheckedChange(receivingList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receivingList]);

  useEffect(() => {
    if (showModal) {
      setValidationError("");
      setError(null);
      ApiManager.Top.cellProducts(
        {
          pickingList: movements
            // ?.filter((row) => row.selected)
            ?.map((row) => ({
              productId: row.productId,
              qty: row.qty,
            })),
        },
        (data) => {
          let tmpReceivingList = movements
            // ?.filter((row) => row.selected)
            ?.map((row) => ({
              ...row,
              pickingList: data?.filter(
                (item) => item.productId === row.productId && item.id !== row.id
              ),
              selectedYear: new Date().getFullYear(),
              selectedQty: row.qty,
            }));

          setReceivingList(tmpReceivingList);
          if (warehouseAreaRef.current) {
            warehouseAreaRef.current.focus();
          }
        },
        (error) => {
          setError(error);
        },
        () => {}
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  const closeModal = () => {
    setShowModal(false);
  };

  const validateFields = () => {
    if (!selectedWarehouseAreaId) {
      return "L'area del magazzino è obbligatoria.";
    }
    if (!selectedRack) {
      return "Il rack è obbligatorio.";
    }
    if (!selectedCol) {
      return "La colonna è obbligatoria.";
    }
    if (!selectedShelf) {
      return "Lo scaffale è obbligatorio.";
    }
    return "";
  };

  const handleYearChange = (index, event) => {
    const newData = [...receivingList];
    newData[index].selectedYear = event.target.value;
    setReceivingList(newData);
  };

  // Handler for quantity select change
  const handleQtyChange = (index, event) => {
    const newData = [...receivingList];
    let selectedQty = parseInt(event.target.value);
    newData[index].selectedQty = selectedQty;
    setReceivingList(newData);
  };

  // Handler for checkbox change
  const handleCheckboxChange = (rowId) => {
    const updatedRows = receivingList.map((row) =>
      row.id === rowId ? { ...row, selected: !row.selected } : row
    );
    setReceivingList(updatedRows);
  };

  const saveModal = () => {
    const error = validateFields();
    if (error) {
      setValidationError(error);
      return;
    }

    const newGuid = uuidv4();

    const incomings = receivingList
      ?.filter((movement) => movement.selected)
      ?.map((movement) => ({
        ...movement,
        productYear: movement.selectedYear,
        qty: movement.selectedQty,
      }));

    ApiManager.Top.stockIncomings(
      newGuid,
      incomings,
      selectedWarehouseAreaId,
      selectedWarehouseAreaDescr,
      selectedRack,
      selectedCol,
      selectedShelf,
      (data) => {
        onSaveModal(data);
        setShowModal(false);
      },
      (error) => {
        console.error("Errore durante il salvataggio:", error);
        setValidationError("Errore durante il salvataggio.");
      },
      () => {}
    );
  };

  const handleCellSelection = (item) => {
    setSelectedWarehouseAreaId(item.warehouseAreaId);
    setSelectedRack(item.rack);
    setSelectedCol(item.col);
    setSelectedShelf(item.shelf);
  };

  return (
    <Modal
      className="incomingModals"
      show={showModal}
      onHide={closeModal}
      size="lg"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <strong className="header-text">Carico</strong>
      </Modal.Header>
      <Modal.Body>
        {validationError && <Alert variant="danger">{validationError}</Alert>}
        <Row className="mb-3">
          <Col>
            <RowCountLabel
              count={receivingList?.length}
              label="Articoli da caricare"
            />
            <Table striped>
              <thead>
                <tr>
                  <th style={{ width: "64px" }}></th>
                  <th>Documento</th>
                  <th>Articolo</th>
                  <th>Fornitore</th>
                  <th className="text-end" style={{ width: "100px" }}>
                    Anno
                  </th>
                  <th className="text-end" style={{ width: "170px" }}>
                    Qta
                  </th>
                  <th>Ubicazione</th>
                </tr>
              </thead>
              <tbody>
                {receivingList
                  // ?.filter((row) => row.selected)
                  ?.map((row, rowIndex) => (
                    <React.Fragment key={`row-${row.id}`}>
                      <tr
                        style={{ verticalAlign: "middle", fontWeight: "bold" }}
                      >
                        <td className="text-center">
                          <CheckBoxComponent
                            id={`qty-${row.id}`}
                            checked={row.selected}
                            onChange={() => handleCheckboxChange(row.id)}
                          />
                        </td>
                        <td>
                          <ul className="list-unstyled">
                            <li>
                              {row.docTypeDescr}&nbsp;
                              {row.docNumb}
                              {row.docSeries?.trim() ? "/" + row.docSeries : ""}
                              &nbsp;
                              {DataManager.Date.format(
                                row.docDate,
                                "dd/MM/yyyy"
                              )}
                              {/* <span className="half-parent-text">&nbsp;{row.id}</span> */}
                            </li>
                            <li>
                              <span className="half-parent-text">
                                {row.transpReasonDescr}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td>
                          <ProductLink {...row} showProductLink={false} />
                        </td>
                        <td>
                          <ul className="list-unstyled">
                            <li>{row.supplierDescr}</li>
                            <li>
                              <span className="half-parent-text">
                                {row.supplierId}
                              </span>
                            </li>
                          </ul>
                        </td>
                        <td className="text-end">
                          <select
                            id={`year-${row.id}`}
                            value={row.selectedYear || currentYear}
                            onChange={(event) =>
                              handleYearChange(rowIndex, event)
                            }
                            className="form-select"
                          >
                            {years.map((year) => (
                              <option
                                key={`year-${row.id}-${year}`}
                                value={year}
                              >
                                {year}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td className="text-end">
                          <div className="d-flex justify-content-between align-items-center">
                            <select
                              id={`qty-${row.id}`}
                              value={row.selectedQty || 0}
                              onChange={(event) =>
                                handleQtyChange(rowIndex, event)
                              }
                              className="form-select text-end"
                              style={{ width: "100px" }}
                            >
                              {Array.from(
                                { length: row.qty },
                                (_, i) => row.qty - i
                              ).map((qty) => (
                                <option
                                  key={`qty-${row.id}-${qty}`}
                                  value={qty}
                                >
                                  {qty}
                                </option>
                              ))}
                            </select>
                            &nbsp; / &nbsp;
                            <span>
                              {DataManager.Decimal.format(row.qty, 0)}
                            </span>
                          </div>
                        </td>
                        <td></td>
                      </tr>
                      {row.pickingList?.length > 0 &&
                        row.pickingList.map(
                          (pickingListItem, pickingListIndex) => (
                            <tr
                              key={`rowPl-${row.id}-${pickingListIndex}`}
                              style={{
                                fontStyle: "italic",
                                opacity: 0.8,
                                verticalAlign: "middle",
                              }}
                            >
                              <td colSpan={2}></td>
                              <td>
                                <ul className="list-unstyled">
                                  <li>{pickingListItem.customerDescr}</li>
                                  <li>
                                    <span className="half-parent-text">
                                      {pickingListItem.customerId}
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td>
                                <ul className="list-unstyled">
                                  <li>{pickingListItem.supplierDescr}</li>
                                  <li>
                                    <span className="half-parent-text">
                                      {pickingListItem.supplierId}
                                    </span>
                                  </li>
                                </ul>
                              </td>
                              <td className="text-end">
                                {pickingListItem.productYear}
                              </td>
                              <td>
                                {DataManager.Decimal.format(
                                  pickingListItem.qty,
                                  0
                                )}
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div>
                                    <>
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                      <a
                                        href="#"
                                        onClick={(event) => {
                                          event.preventDefault();
                                          handleCellSelection(pickingListItem);
                                        }}
                                      >
                                        <ul className="list-unstyled">
                                          <li>
                                            {pickingListItem.warehouseAreaDescr}
                                            -{pickingListItem.rack}-
                                            {pickingListItem.col}-
                                            {pickingListItem.shelf}
                                          </li>
                                          <li>
                                            {pickingListItem.lastMovData && (
                                              <span className="half-parent-text">
                                                {`Ult. mov. ${pickingListItem.lastMovData}`}
                                              </span>
                                            )}
                                          </li>
                                        </ul>
                                      </a>
                                    </>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )
                        )}
                    </React.Fragment>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
        <strong className="header-text">Ubicazione di destinazione</strong>
        <CellSelector
          idPrefix="ModalMovementIncomings"
          ref={warehouseAreaRef}
          selectedWarehouseAreaId={selectedWarehouseAreaId}
          setSelectedWarehouseAreaId={setSelectedWarehouseAreaId}
          selectedWarehouseAreaDescr={selectedWarehouseAreaDescr}
          setSelectedWarehouseAreaDescr={setSelectedWarehouseAreaDescr}
          selectedRack={selectedRack}
          setSelectedRack={setSelectedRack}
          selectedCol={selectedCol}
          setSelectedCol={setSelectedCol}
          selectedShelf={selectedShelf}
          setSelectedShelf={setSelectedShelf}
          editMode={true}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          title="Salva"
          variant="success"
          onClick={saveModal}
          disabled={
            !selectedWarehouseAreaId ||
            !selectedRack ||
            !selectedCol ||
            !selectedShelf
          }
        >
          <SaveAltIcon />
        </Button>
        {/* <Button variant="secondary" onClick={closeModal}>
          Chiudi
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalMovementIncomings;
